import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'wsb-confirm-tab-switch',
  templateUrl: './confirm-tab-switch.component.html',
  styleUrls: ['./confirm-tab-switch.component.scss'],
  standalone: false
})
export class ConfirmTabSwitchComponent {
  constructor(public modal: NgbActiveModal) {}
}
